import React, { Component } from "react";

import UI from "../../../actions/ui-helper";
import DataUtil from "../../../actions/data";
import StringUtil from "../../../actions/string";

class ConsultaUsuarioLogResultado extends Component {

  componentWillUpdate() {
    UI.destroyTable(this.tableId);
  }

  componentDidUpdate() {
    UI.dataTable(this.tableId);
  }

  render() {
    if (this.props.resultado.length === 0) {
      return false;
    }
    var realceR = {
      color: "#770000"
    };
    var realceG = {
      color: "#007700"
    };

    var tipoLog = ["", "LOGIN", "LOGOUT"];
    var styleLog = [null, realceG, realceR];
    this.tableId = StringUtil.uuid(5);

    return (
      <div className="row">
        <div className="col-12 grid-margin">
          <div className="row">
            <div className="col-12 table-responsive">
              <table key={StringUtil.uuid(5)} id={this.tableId} className="table">
                <thead>
                  <tr>
                    <th>Data Hora</th>
                    <th>Nome</th>
                    <th>E-mail</th>
                    <th>Tipo</th>
                    <th>Descrição</th>
                  </tr>
                </thead>
                <tbody>
                  {this.props.resultado.map((log, i) => {
                    return (
                      <tr key={log.id}>
                        <td>
                          <span hidden>{i.toString().padStart(5, '0')}</span>
                          <b style={DataUtil.fimDeSemana(log.dataHora) ? realceR : null}>
                            {DataUtil.diaSemana(log.dataHora)}</b> - {log.dataHora}</td>
                        <td>{log.usuario.nome}</td>
                        <td>{log.usuario.email}</td>
                        <td>
                          <b style={styleLog[log.tipo]}>{tipoLog[log.tipo]}</b></td>
                        <td>{log.descricao}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default ConsultaUsuarioLogResultado;
